import React from 'react'
import classnames from 'classnames'

import './checkbox.sass'

const Checkbox = ({ toggled }) =>
  <div className={classnames('checkbox', {toggled: toggled})}></div>

export default Checkbox
